import React from 'react';

let OfferUpdateContext;
const { Provider } = (OfferUpdateContext = React.createContext());

const OfferUpdateContextProvider = ({ children }) => {
  const [offerUpdateIdForEdit, setOfferUpdateIdForEdit] = React.useState(null);
  return (
    <Provider value={{ offerUpdateIdForEdit, setOfferUpdateIdForEdit }}>
      {children}
    </Provider>
  );
};

export { OfferUpdateContext, OfferUpdateContextProvider };
